var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5a5a5a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,16.387l5.571,3.529a.547.547,0,0,0,.808-.611L14.9,12.654l4.914-4.468a.575.575,0,0,0-.313-1l-6.476-.577L10.493.348a.527.527,0,0,0-.991,0L6.969,6.614.493,7.191a.573.573,0,0,0-.3,1L5.1,12.654,3.629,19.305a.547.547,0,0,0,.808.611Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.4513ef58caabfdcae9061454c555aac6.svg";
export { ForwardRef as ReactComponent };